import { render, staticRenderFns } from "./user_shoppingcart_payment.vue?vue&type=template&id=f13b56d6&scoped=true&"
import script from "./user_shoppingcart_payment.vue?vue&type=script&lang=js&"
export * from "./user_shoppingcart_payment.vue?vue&type=script&lang=js&"
import style0 from "./user_shoppingcart_payment.vue?vue&type=style&index=0&id=f13b56d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13b56d6",
  null
  
)

export default component.exports